import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { last } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'  // This makes it globally available
})
export class RecipientsFilterService {
  // Observable string sources
  private sourceEle = {
    label: '',
    value: ''
  };
  private sourceDataSource = new BehaviorSubject(this.sourceEle);
  private filterRecipientData = new Subject<[]>();
  private warningfilterRecipientData = new Subject<[]>();
  // Observable string streams

  public sourceDataobservable$ = this.sourceDataSource.asObservable();
  public filterData$ = this.filterRecipientData.asObservable();
  public warningfilterData$ = this.warningfilterRecipientData.asObservable();


  public warningDataList = [];
  public srcFilteredDataList = [];
  // Service message commands

  
  public setSourceName(d: any): void {
    this.sourceEle.label = d;
    this.sourceEle.value = d;
    // console.log('the options which we r looking:-',this.sourceEle);
    this.sourceDataSource.next(this.sourceEle);
    this.sourceEle = { label: '', value: '' };
  }
  public getfilteredData(objArr:any): void {
    this.filterRecipientData.next(objArr);
  }

  public getFilteredData(ls,_data): void{
    let data=_data
      if(ls[0] == "email" && ls[1] == "account ids"){
        let res1=data.filter(i => {
          if(this.isDuplicatedEmail(data,i)){
            return i
          }
        });
        let res2=data.filter(i=>{
          if(i.customerId===undefined || '' || null){
            return i
        }})
        let res4=data.filter(i => {
          if(this.isDuplicatedName(data,i)){
            return i
          }
        });
        if(res1.length!=0){
          let res6;
          if(res2.length!=0 && res4.length!=0){
            res6= res2.concat(res4)
            let res7= res1.filter(i => !res6.includes(i));
            let res8= res6.filter(i => !res1.includes(i));
            let intersection = res1.filter(value => res6.includes(value));
            let res= res7.concat(res8,intersection)
            this.warningfilterRecipientData.next(res);
          }
          else if(res2.length==0 && res4.length!=0){
            res6=res4
            let res7= res1.filter(i => !res6.includes(i));
            let res8= res6.filter(i => !res1.includes(i));
            let intersection = res1.filter(value => res6.includes(value));
            let res= res7.concat(res8,intersection)
            this.warningfilterRecipientData.next(res);
          }
          else if(res2.length!=0 && res4.length==0){
            res6= res2
            let res7= res1.filter(i => !res6.includes(i));
            let res8= res6.filter(i => !res1.includes(i));
            let intersection = res1.filter(value => res6.includes(value));
            let res= res7.concat(res8,intersection)
            this.warningfilterRecipientData.next(res);
          }
          else{
            let res= res1
            this.warningfilterRecipientData.next(res);
          }
        }
        else{
          let res;
          if(res2.length!=0 && res4.length!=0){
            res= res2.concat(res4)
            this.warningfilterRecipientData.next(res);
          }
          else if(res2.length==0 && res4.length!=0){
            res=res4
            this.warningfilterRecipientData.next(res);
          }
          else if(res2.length!=0 && res4.length==0){
            res= res2
            this.warningfilterRecipientData.next(res);
          }
          else{
            this.warningfilterRecipientData.next([]);
          }
        }
      }
      else if(ls[0] == "email" && ls.length==1){
        let res=data.filter(i => {
          if(this.isDuplicatedEmail(data,i)){
            return i
          }
        });
        if(res.length!=0){
          this.warningfilterRecipientData.next(res);
        }
        else{
          this.warningfilterRecipientData.next([]);
        }
      }
      else if(ls[0] == "account ids" && ls.length==1){
        let res1=data.filter(i=>{
          if(i.customerId===undefined || '' || null){
            return i
        }})
        let res2=data.filter(i => {
          if(this.isDuplicatedName(data,i)){
            return i
          }
        });
        if(res1.length!=0 && res2.length!=0){
            let res= res1.concat(res2)
            this.warningfilterRecipientData.next(res);
        }
        else if(res1.length!=0 && res2.length==0){
            let res= res1
            this.warningfilterRecipientData.next(res);
        }
        else if(res2.length!=0 && res1.length==0){
            let res= res2
            this.warningfilterRecipientData.next(res);
        }
        else{
            let res=[]
            this.warningfilterRecipientData.next([]);
        }
      }
      else{ 
        this.warningfilterRecipientData.next(data);
      }
    
  }



  public isDuplicated(d: any, target: any): boolean{
    if(!d || !target) return false;
    return this.isDuplicatedEmail(d, target) || this.isDuplicatedName(d, target);
  }

  public isDuplicatedEmail(d: any, target: any): boolean{
    if(!d || !target) return false;
    const targetIndex = d.indexOf(target);
    return d.some((obj, index) => 
      index !== targetIndex && 
      obj.customerId === target.customerId &&
      obj.customerEmail === target.customerEmail);
  }

  public isDuplicatedName(d: any, target: any): boolean{
    if(!d || !target) return false;
    const targetIndex = d.indexOf(target);
    return d.some((obj, index) => 
      index !== targetIndex && 
      obj.customerId === target.customerId && 
      obj.customerName !== target.customerName);
  }

  public findDuplicates(arr) {
    return arr.filter((target, index) => {
      return (
        arr.some((obj, targetIndex) => 
        index !== targetIndex && 
        obj.customerId === target.customerId &&
        obj.customerEmail === target.customerEmail)
      )
      || (
        arr.some((obj, targetIndex)  => 
        index !== targetIndex && 
        obj.customerId === target.customerId && 
        obj.customerName !== target.customerName)
      ) ;
    });
  }
  
}
